import { Component, HostBinding, Input } from '@angular/core';
import { MuiIconFont } from '../../icon';

@Component({
  selector: 'mui-hero-action, button[mui-hero-action]',
  templateUrl: './mui-hero-action-button.component.html'
})
/**
 * @deprecated Use the `MuiFab` component instead.
 */
export class MuiHeroActionButton {
  @Input() icon = 'plus';
  @Input() iconFont: MuiIconFont | string = MuiIconFont.FONTAWESOME;

  @Input()
  @HostBinding('attr.aria-label')
  label: string | null = null;

  @HostBinding('class.mui-hero-action-button') readonly _muiBaseClass = true;
  @HostBinding('attr.role') readonly role = 'button';

  constructor() {
    console.warn('[MuiHeroActionButton] This component is deprecated. Use the `MuiFab` component instead.');
  }
}
